class LLCartPoints extends HHBaseElement {
  constructor() {
    super(`
    <slot></slot>
  `)
  }

  get cartTotalElement() {
    return this.querySelector(`[data-lion-points-for]`)
  }

  connectedCallback() {
    document.addEventListener('cart::add', this.updatePoints.bind(this))
    document.addEventListener('cart::update', this.updatePoints.bind(this))
    document.addEventListener(
      'main-cart::refreshed',
      this.updatePoints.bind(this)
    )
  }

  disconnectedCallback() {
    document.removeEventListener('cart::add', this.updatePoints.bind(this))
    document.removeEventListener('cart::update', this.updatePoints.bind(this))
    document.removeEventListener(
      'main-cart::refreshed',
      this.updatePoints.bind(this)
    )
  }

  async updatePoints() {
    await window.__CART__CONTROLLER__.get()
    if (this.cartTotalElement) {
      this.cartTotalElement.setAttribute(
        'data-lion-points-for',
        window.__CART__.total_price
      )
      window.lion?.ui.refresh()
    }
  }
}

window.customElements.define('ll-cart-points', LLCartPoints)
